import cx from "classnames";
import React from "react";
import { IoClose } from "react-icons/io5";
import "./ChatPopup.css";

interface Props {
  showPopup: boolean;
  popperStyles: React.CSSProperties;
  arrowStyles: React.CSSProperties;
  setPopupRef: any;
  setArrowRef: any;
  onCloseRequest: () => void;
}

export const ChatPopup = ({
  showPopup,
  popperStyles,
  arrowStyles,
  setPopupRef,
  setArrowRef,
  onCloseRequest,
  ...attributes
}: Props) => {
  return (
    <div
      id="popup"
      className={cx(
        "p-4 bg-a-purple text-white font-bold rounded-md w-[50vw] md:w-[260px] mb-4 shadow-lg",
        {
          invisible: !showPopup,
          visible: showPopup
        }
      )}
      style={popperStyles}
      {...attributes}
      ref={setPopupRef}>
      <div className="fixed top-[-9px] right-[-11px] p-3 cursor-pointer" onClick={onCloseRequest}>
        <IoClose fontSize={20} className="font-bold" />
      </div>
      <div className="flex flex-col">
        <p className="mb-4 text-lg">Vrei sa comunici cu noi si cu ascultatorii Radio OM Bun?</p>
        <p className="text-lg">
          Scrie <strong>AICI</strong>
        </p>
        {/* <p className="text-md">Stiai ca avem chat online? Apasa butonul mai jos</p> */}
      </div>
      <div id="arrow" className="border-l-[1px]" ref={setArrowRef} style={arrowStyles}></div>
    </div>
  );
};
